__turbopack_context__.v({
  "created-by": "instructor-display-module-scss-module__-KB2AG__created-by",
  "google-icon": "instructor-display-module-scss-module__-KB2AG__google-icon",
  "instructor-container": "instructor-display-module-scss-module__-KB2AG__instructor-container",
  "instructor-link": "instructor-display-module-scss-module__-KB2AG__instructor-link",
});
